function CategoryCard({ category, itemCount, onClick }) {
  const Icon = category.Icon;
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-3 rounded-2xl border border-border bg-background p-4 text-left transition hover:bg-secondary"
    >
      <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${category.iconBg} ${category.iconColor}`}>
        <Icon size={24} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">{category.name}</div>
        <div className="text-xs text-muted-foreground">{itemCount} items</div>
      </div>
    </button>
  );
}

export default CategoryCard;
